import { Badge } from '@/components/ui/badge';
import type { PackingSlipStatus } from '../../types';

interface PackingSlipStatusBadgeProps {
  status: PackingSlipStatus;
}

const statusConfig: Record<PackingSlipStatus, { label: string; variant: 'default' | 'secondary' | 'outline' | 'destructive' }> = {
  draft: { label: 'Draft', variant: 'secondary' },
  packing: { label: 'Packing', variant: 'default' },
  packed: { label: 'Packed', variant: 'outline' },
  shipped: { label: 'Shipped', variant: 'default' },
  delivered: { label: 'Delivered', variant: 'default' },
  cancelled: { label: 'Cancelled', variant: 'destructive' },
};

export function PackingSlipStatusBadge({ status }: PackingSlipStatusBadgeProps) {
  const config = statusConfig[status] || { label: status, variant: 'secondary' as const };

  const colorClasses: Record<PackingSlipStatus, string> = {
    draft: 'bg-gray-100 text-gray-800 hover:bg-gray-100',
    packing: 'bg-yellow-100 text-yellow-800 hover:bg-yellow-100',
    packed: 'bg-blue-100 text-blue-800 hover:bg-blue-100',
    shipped: 'bg-purple-100 text-purple-800 hover:bg-purple-100',
    delivered: 'bg-green-100 text-green-800 hover:bg-green-100',
    cancelled: 'bg-red-100 text-red-800 hover:bg-red-100',
  };

  return (
    <Badge
      variant={config.variant}
      className={colorClasses[status]}
    >
      {config.label}
    </Badge>
  );
}
